import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MdLogout } from "react-icons/md";
import { clearToken } from "../../store";

const apiUrl = import.meta.env.VITE_API_URL;
const apiRoute = "logout";
const apiEndpoint = `${apiUrl}${apiRoute}`;

const LogoutButton = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Make a POST request here
    fetch(apiEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      credentials: "include",
      body: new URLSearchParams({}),
    })
      .then((response) => response.json())
      .then(() => {
        // Clear the token from Redux state and sessionStorage
        dispatch(clearToken());
      })
      .catch((error) => {
        // Handle the error
        console.error(error);
      })
      .finally(() => {
        setIsLoading(false);
        navigate("/");
        window.location.reload();
      });
  };

  return (
    <>
      <button
        className="btn btn-ghost border border-base-content/20  "
        onClick={handleSubmit}
      >
        {isLoading ? (
          "Loading..."
        ) : (
          <>
            <MdLogout size={20} /> Logga ut
          </>
        )}
      </button>
    </>
  );
};

export default LogoutButton;
